import React from 'react';
import { Github, Linkedin, Globe } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export const Footer: React.FC = () => {
  const { theme } = useTheme();
  
  return (
    <footer className="theme-bg-sidebar backdrop-blur-sm border-t theme-border-sidebar px-4 py-3 md:hidden">
      <div className="flex items-center justify-between">
        {/* Left side - Branding */}
        <div className="flex items-center space-x-2">
          <img 
            src={theme === 'light' ? '/politheon-logo.png' : '/politheon-logo-light.png'}
            alt="Politheon Logo" 
            className="w-6 h-6 object-contain"
          />
          <span className="text-sm theme-text-muted font-medium">
            Politheon Policy AI
          </span>
        </div>
        
        {/* Right side - Social links */}
        <div className="flex items-center space-x-2">
          <a
            href="https://www.linkedin.com/company/politheon/"
            target="_blank"
            rel="noopener noreferrer"
            className="theme-text-muted hover:text-blue-400 transition-colors duration-200 p-1.5 rounded-lg hover:theme-bg-sidebar-hover"
            title="Follow us on LinkedIn"
          >
            <Linkedin className="w-4 h-4" />
          </a>
          
          <a
            href="https://github.com/Politheon-HQ"
            target="_blank"
            rel="noopener noreferrer"
            className="theme-text-muted hover:theme-text-primary transition-colors duration-200 p-1.5 rounded-lg hover:theme-bg-sidebar-hover"
            title="View our GitHub"
          >
            <Github className="w-4 h-4" />
          </a>

          <a
            href="https://politheon.com"
            target="_blank"
            rel="noopener noreferrer"
            className="theme-text-muted hover:text-emerald-400 transition-colors duration-200 p-1.5 rounded-lg hover:theme-bg-sidebar-hover"
            title="Visit our Website"
          >
            <Globe className="w-4 h-4" />
          </a>
        </div>
      </div>
    </footer>
  );
};
